import React from "react";
import Dashboard from "../../../components/Dashboard";
import {
  WizardTitle,
  notifyError,
  createSortByName,
  UnderConstruction,
  scrollToElement,
  USER_STATUS_IDS,
  isSpecialKDL,
} from "../../../components/Utils";
import { FormMenu } from "../../../components/Buttons";
import {
  setCompanyModel,
  getCompanyModel,
  renderWorkerDetailsMenu,
} from "../components/Utils";

import BasicDataForm from "../components/wizard/BasicDataForm";
import ITConnectionForm from "../components/wizard/ITConnectionForm";
import CertificationListForm from "../components/wizard/CertificationListForm";
import UserDeviceListForm from "../../Device/components/UserDeviceListForm";
import TechKeyListForm from "../components/wizard/TechKeyListForm";
import UserTrainingPanel from "../components/panels/UserTrainingPanel";
import WorkerBasicDataMenu from "../components/WorkerBasicDataMenu";
// import ContractorCompanyPanel from "../components/panels/ContractorCompanyPanel";
// import UserTechDeviceListForm from "../../Device/components/UserTechDeviceListForm";
// import { TechKeyForm } from "../../Company/components";
// import { UserDeviceListPanel, UserRatingPanel } from "../components/panels";
// import AuditListForm from "../components/wizard/AuditListForm";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import {
  // loadExtendedRoles,
  initWorker,
  loadWorker,
  checkWorker,
  saveWorker,
  cancelWorker,
} from "../actions";
import { loadTechDevices } from "../../Device/actions";
import {
  PermissionGroupFetcher,
  PermissionResource,
  PermissionResourceList,
  PermissionSection,
  Resources,
} from "../../Permissions";
import {
  isResourceEditable,
  isResourceReadable,
} from "../../Permissions/actions";
import ITConnectionHeader from "../components/ITConnectionHeader";
import NGUMStatusObserver from "../../NGum/containers/NGUMStatusObserver";

const frontload = async (props) => {
  await props.getTechDevices();
  // await props.getExtendedRoles();
  const id = props.match.params.id;
  await props.getWorker({ id });
  await props.init(true);
};
const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    // permissions: state.permissions.permissionGroup.admindataaccess,
    permissions: state.permissions.permissionMap,
    isInitialized: state.worker.isInitialized,
    worker: state.worker.worker,
    userChecked: state.worker.userChecked,
    userExists: state.worker.userExists,
    roles: state.worker.roles,
    extendedRoles: state.worker.extendedRoles,
    kdls: state.worker.workerKDLs,
    userCompany: state.company.company,
    techDevices: state.device.techDevices,
    userTrainings: state.training.userTrainings,
    techKeyList: state.company.techKeys,
    // techKeyList: state.key.catalogKeys,
  };
};
const mapDispatchToProps = (dispatch) => ({
  init: (...args) => dispatch(initWorker(...args)),
  getTechDevices: (...args) => dispatch(loadTechDevices(...args)),
  getWorker: (...args) => dispatch(loadWorker(...args)),
  checkWorker: (...args) => dispatch(checkWorker(...args)),
  saveWorker: (...args) => dispatch(saveWorker(...args)),
  cancelWorker: (...args) => dispatch(cancelWorker(...args)),
});

const Wizard = React.memo(function Wizard(props) {
  const {
    className = "",
    history,
    permissions,
    worker,
    kdls,
    userCompany,
    roles,
    extendedRoles,
    userChecked,
    userExists: userExistsProp,
    techKeyList,
    disabled,
    checkWorker,
    saveWorker,
    cancelWorker,
  } = props;

  const baseDataRef = React.useRef(null);
  const itDataRef = React.useRef(null);
  const techKeysRef = React.useRef(null);
  const certificatesRef = React.useRef(null);
  // vfEmail and tech-device forms are currently not rendered; their refs
  // stay unassigned and the guards below keep the previous behavior
  const vfEmailRef = React.useRef(null);
  const userTechDevicesRef = React.useRef(null);

  React.useEffect(() => {
    // reset state on unmount
    return () => {
      cancelWorker();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckWorker = (worker) => {
    checkWorker(worker);
  };
  const onSave = () => {
    // ----------------------------------- //
    // Basic Info
    // ----------------------------------- //
    let baseData = baseDataRef.current ? baseDataRef.current.getModel() : null;
    if (!baseData && baseDataRef.current) {
      return notifyError({
        summary: "Allgemeine Daten Fehler",
        detail: `Der Mitarbeiter konnte nicht gespeichert werden. Bitte Ihre Eingaben überprüfen.`,
      });
    }
    baseData = baseData || { ...worker };
    let model = { ...baseData };

    // ensure companies array exists with at least one company for proper saving of related data
    if (!model.companies || model.companies.length === 0) {
      return notifyError({
        summary: "Beschäftigungsfirma Fehler",
        detail: `Der Mitarbeiter muss mindestens eine Beschäftigungsfirma haben.`,
      });
    }

    // check if company was changed
    let isCompanyChanged = false;
    for (const company of model.companies) {
      if (company.contractGiver !== company.oldContractGiver) {
        isCompanyChanged = true;
      }
    }

    // VF Email
    const vfEmailModel = vfEmailRef.current
      ? vfEmailRef.current.getModel()
      : null;
    if (vfEmailModel) {
      model.vf_email = vfEmailModel.email;
    }

    // ----------------------------------- //
    // IT Connections
    // ----------------------------------- //
    const connectionData = itDataRef.current
      ? itDataRef.current.getModel()
      : null;
    if (connectionData) {
      const { delphiConnections, ...itConnectionData } = connectionData;

      // DELPHI Connections
      // validate delphi connections and assign to company
      if (delphiConnections && Array.isArray(delphiConnections)) {
        for (const delphiConnection of delphiConnections) {
          for (const company of model.companies) {
            if (delphiConnection.parentCompanyName !== company.contractGiver) {
              // delphiConnection could not be assigned to company => abort
              scrollToElement("delphi-zugaenge");
              return notifyError({
                summary: "Mitarbeiterprofil - DELPHI-Zugangsfehler",
                detail: `Der DELPHI-Zugang (KDL: ${delphiConnection.parentCompanyName}) konnte nicht zugewiesen werden.`,
              });
            }
          }
        }
        model.companies[0].delphiConnections = delphiConnections;
      }

      // JARVIS Connection
      // validate jarvis connection and assign to company
      const jarvisConnection = itConnectionData.jarvisConnection;
      if (jarvisConnection) {
        for (const company of model.companies) {
          if (jarvisConnection.parentCompanyName !== company.contractGiver) {
            scrollToElement("jarvis-zugang");
            return notifyError({
              summary: "Mitarbeiterprofil - JARVIS-Zugangsfehler",
              detail: `Der JARVIS-Zugang (KDL: ${jarvisConnection.parentCompanyName}) konnte nicht zugewiesen werden.`,
            });
          }
        }
      }

      model.itConnectionData = itConnectionData;
      if (
        !isCompanyChanged &&
        worker.itConnectionData &&
        worker.itConnectionData.id
      ) {
        model.itConnectionData.id = worker.itConnectionData.id;
      }
    }

    // ----------------------------------- //
    // Tech Keys
    // ----------------------------------- //
    const techKeys = techKeysRef.current
      ? techKeysRef.current.getModel()
      : null;
    model.techKeys = techKeys;
    // ----------------------------------- //
    // Tech Devices
    // ----------------------------------- //
    if (userTechDevicesRef.current) {
      const techDevices = userTechDevicesRef.current.getModel();
      if (techDevices) {
        const unassignedDevice = setCompanyModel(
          model,
          techDevices,
          "techDevices",
          "companyName",
          isCompanyChanged,
        );
        if (unassignedDevice) {
          // tech device could not be assigned to company => abort
          const companyName = unassignedDevice.companyName;
          scrollToElement("vkdg-geraete");
          return notifyError({
            summary: "Mitarbeiterprofil - Technikergerätfehler",
            detail: `Das Technikergerät (${unassignedDevice.device}, Beschäftigungsfirma: ${companyName}) konnte nicht zugewiesen werden.`,
          });
        }
      }
    }
    // ----------------------------------- //
    // Certifications
    // ----------------------------------- //
    const certificates = certificatesRef.current
      ? certificatesRef.current.getModel()
      : null;
    if (certificates) {
      model.certificates = certificates;
    }
    if (worker.id) {
      model.id = worker.id;
    }
    const onSuccess = () => history.replace("/organisation/mitarbeiter");
    saveWorker(model, onSuccess);
  };
  const onCancel = () => {
    cancelWorker();
    history.replace("/organisation/mitarbeiter");
  };
  const getUserDeviceListBaseData = () => {
    const baseData = baseDataRef.current.getModel(true);
    return {
      currentWorker: worker,
      currentWorkerCompany:
        baseData.companies.length > 0 ? baseData.companies[0] : null,
    };
  };
  const getCompanyData = () => {
    let companyData = { isContractor: false };
    if (baseDataRef.current) {
      companyData = baseDataRef.current.getCompanyData();
    }
    return companyData;
  };
  const getEmployeeData = () => {
    let employeeData = { email: "" };
    if (baseDataRef.current) {
      const model = baseDataRef.current.getModel();
      if (model) {
        employeeData = model;
      }
    }
    return employeeData;
  };
  const isWorkerEditable = () => {
    const resourceKeys = Object.keys(Resources.Organisation.WorkerWizard);
    for (const key of resourceKeys) {
      const isWriteable = isResourceEditable(
        Resources.Organisation.WorkerWizard[key],
        permissions,
      );
      if (isWriteable) {
        return (
          !worker.status_id || worker.status_id === USER_STATUS_IDS.APPROVED
        );
      }
    }
    return false;
  };

  if (!worker) return null;

  // user check status
  const canReadAdminData = isResourceReadable(
    Resources.AdminDataAccess,
    permissions,
  );
  const userExists = worker.id !== undefined || userExistsProp;

  // main company
  const mainCompany =
    worker.companies.length === 1
      ? worker.companies[0]
      : worker.companies.find((item) => item.role && item.role !== "");
  const isDL = isSpecialKDL({ type_id: mainCompany.parentCompanyTypeId });

  const kdlCompanyList = kdls.sort(createSortByName());

  const flag = Boolean((worker.id !== undefined || userChecked) && worker.id);
  const Menu = renderWorkerDetailsMenu(flag);

  // IT Connections
  const itConnectionData = worker.itConnectionData || {};
  let visibleDelphiCompanies = null;
  itConnectionData.delphiConnections = getCompanyModel(
    worker,
    "delphiConnections",
    visibleDelphiCompanies,
  );
  itConnectionData.vfEmail = worker.vf_email;
  itConnectionData.isAutheticatorRegistered = worker.hasMsAuthenticator;
  // Devices
  const userDevices = getCompanyModel(worker, "devices");
  const userDisabled = !isWorkerEditable();
  return (
    <div className={`worker-wizard clearfix ${className}`}>
      <PermissionGroupFetcher group="Organisation.WorkerWizard" />
      <WizardTitle
        type="worker"
        model={worker}
        menu={
          <FormMenu
            className="pad-big-top"
            onSave={onSave}
            onCancel={onCancel}
            saveDisabled={!worker.id && userChecked === false}
            saveBtnName="saveWorkerBtn2"
            cancelBtnName="cancelWorkerBtn2"
            saveHidden={disabled || userDisabled}
            cancelBtnLabel={userDisabled ? "Schließen" : undefined}
          />
        }
      />
      <div className="container">
        <Dashboard menu={Menu} menuSize={3} key={Math.random()}>
          <PermissionResource
            resource={Resources.Organisation.WorkerWizard.BasicInfo}
          >
            <PermissionSection
              height="30"
              id="basisdaten"
              className="w3-border margin-big-top pad-big"
              isUnterWizardTitle
            >
              <NGUMStatusObserver>
                <WorkerBasicDataMenu className="w3-right" user={worker} />
              </NGUMStatusObserver>
              <h3 className="no-margin-top">{"Persönliche Daten"}</h3>
              <BasicDataForm
                ref={baseDataRef}
                model={worker}
                kdlCompanyList={kdlCompanyList}
                contractGivers={worker.contractGivers}
                userCompany={userCompany}
                roleList={roles}
                extendedRoleList={extendedRoles}
                checkUser={onCheckWorker}
                userChecked={userChecked}
                userExists={userExists}
                canReadAdminData={canReadAdminData}
                readOnly={userDisabled}
              />
            </PermissionSection>
          </PermissionResource>
          {flag && (
            <>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.IDCard}
              >
                <PermissionSection
                  height="30"
                  id="vkdg-ausweis"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <h3 className="no-margin-top">{"VKDG Ausweis"}</h3>
                  <UnderConstruction />
                </PermissionSection>
              </PermissionResource>
              <PermissionResourceList
                resources={[
                  Resources.Organisation.WorkerWizard.ADConnections,
                  Resources.Organisation.WorkerWizard.ANPAccount,
                  Resources.Organisation.WorkerWizard.PTConnections,
                  Resources.Organisation.WorkerWizard.DelphiConnections,
                  Resources.Organisation.WorkerWizard.JarvisConnection,
                ]}
              >
                <PermissionSection
                  height="30"
                  id="it-zugaenge"
                  className="w3-border margin-big-top"
                  isUnterWizardTitle
                >
                  <ITConnectionHeader
                    title={"IT-Zugänge"}
                    targetId="itConnectionHeaderEnd"
                    targetPosition={160 + 74} // 160px for header + 74px for sticky header
                    isSticky
                  />
                  <ITConnectionForm
                    ref={itDataRef}
                    className="pad-big-lr pad-big-btm-"
                    model={{
                      ...itConnectionData,
                      vf_email: worker.vf_email,
                      isAutheticatorRegistered: worker.hasMsAuthenticator,
                    }}
                    kdlCompanyList={worker.contractGivers}
                    userCompany={userCompany}
                    canReadAdminData={canReadAdminData}
                    vfEmailPermission={
                      permissions[
                        Resources.Organisation.WorkerWizard.VodafoneEmail
                      ]
                    }
                    ngumUserIdPermission={
                      permissions[
                        Resources.Organisation.WorkerWizard
                          .ADConnectionNGUMStatusID
                      ]
                    }
                    disabled={disabled}
                    roleList={roles}
                    getCompanyData={getCompanyData}
                    getEmployeeData={getEmployeeData}
                    userDisabled={userDisabled}
                    isDL={isDL}
                  />
                  <div id="itConnectionHeaderEnd" />
                </PermissionSection>
              </PermissionResourceList>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.UserDevices}
              >
                <PermissionSection
                  height="30"
                  id="messgeraete"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  {/* <UserDeviceListPanel model={userDevices} /> */}
                  <UserDeviceListForm
                    model={userDevices}
                    getBaseData={getUserDeviceListBaseData}
                    readOnly
                  />
                </PermissionSection>
              </PermissionResource>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.TechKeys}
              >
                <PermissionSection
                  height="30"
                  id="schluessel"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <TechKeyListForm
                    ref={techKeysRef}
                    model={worker.techKeys}
                    company={mainCompany}
                    companyKeys={techKeyList || []}
                    readOnly={userDisabled}
                  />
                </PermissionSection>
              </PermissionResource>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.Certifications}
              >
                <PermissionSection
                  height="30"
                  id="zertifizierungen"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <CertificationListForm
                    ref={certificatesRef}
                    model={worker.certificates}
                    readOnly={userDisabled}
                  />
                </PermissionSection>
              </PermissionResource>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.TechDevices}
              >
                <PermissionSection
                  height="30"
                  id="vkdg-geraete"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <h3 className="no-margin">
                    {"VKDG Geräte / Technikergeräte"}
                  </h3>
                  <UnderConstruction />
                  {/* <UserTechDeviceListForm
                    ref={ref => userTechDevicesRef.current = ref}
                    model={worker.techDevices}
                    getBaseData={getUserDeviceListBaseData}
                  /> */}
                </PermissionSection>
              </PermissionResource>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.Seminars}
              >
                <PermissionSection
                  height="30"
                  id="schulungen"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <h3 className="no-margin-top">{"Schulungen"}</h3>
                  <UserTrainingPanel model={worker.trainings} isEditable />
                </PermissionSection>
              </PermissionResource>
              <PermissionResource
                resource={Resources.Organisation.WorkerWizard.Audits}
              >
                <PermissionSection
                  height="30"
                  id="auditierung"
                  className="w3-border margin-big-top pad-big"
                  isUnterWizardTitle
                >
                  <h3 className="no-margin-top">{"Auditierung"}</h3>
                  <UnderConstruction />
                  {/* <AuditListForm
                    ref={ref => auditsRef.current = ref}
                    model={worker.audits}
                  /> */}
                </PermissionSection>
              </PermissionResource>
              <div id="WorkerWizardEnd" />
            </>
          )}
          <FormMenu
            className="w3-border margin-big-top pad-big w3-light-grey"
            onSave={onSave}
            onCancel={onCancel}
            saveDisabled={!worker.id && userChecked === false}
            saveBtnName="saveWorkerBtn"
            cancelBtnName="cancelWorkerBtn"
            saveHidden={disabled || userDisabled}
            cancelBtnLabel={userDisabled ? "Schließen" : undefined}
          />
        </Dashboard>
      </div>
    </div>
  );
},
// replica of shouldComponentUpdate(nextProps) { return nextProps.isInitialized; }
(prevProps, nextProps) => !nextProps.isInitialized);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Wizard),
);
